import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PrivateContext } from "lib/context";
import { Spinner } from "lib/components";
import { baseHelper, errorHelper, storageHelper } from "lib/helpers";

import { SAVE_SHOPIFY_CALLBACK } from "app/productOld/apollo/mutations";
import { useMutation } from "@apollo/client";
import constant from "lib/constant/constant";
import { withErrorBoundary } from "lib/hoc";

const GenericShopifyCallback = () => {
  const { currentUser, cms = () => {}, isLoading } = useContext(PrivateContext);
  const isSeller = baseHelper.isSeller(currentUser);
  const isVendor = baseHelper.isVendor(currentUser);
  const [getShopifyCallback] = useMutation(SAVE_SHOPIFY_CALLBACK);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = baseHelper.getQueryParams(location.search);

  const data = {
    shop: queryParams.shop,
    code: queryParams.code,
  };

  const shopParam = "?shop=true";
  const route = isSeller ? `/${shopParam}` : isVendor ? `/products/add${shopParam}` : "/";

  // ComponentDidMount: Call GET_SHOPIFY_CALLBACK mutation and show success or error banner
  useEffect(() => {
    if (!isLoading) {
      getShopifyCallback({ variables: { input: data } })
        .then((res) => {
          let bannerData = { title: cms("message.success.shop"), status: constant.SUCCESS };
          const resError = baseHelper.getResponseError(res.data, constant.gql.SAVE_SHOPIFY_VENDOR);
          if (resError) {
            bannerData = { title: resError, status: constant.CRITICAL };
          }
          if (isSeller) {
            storageHelper.set("setupProgress", "finish");
          }
          navigate(route, { state: { bannerData } });
        })
        .catch((exception) => {
          const bannerData = { title: errorHelper.parse(exception), status: constant.CRITICAL };
          navigate(route, { state: { bannerData } });
        });
    }
  }, [isLoading, isSeller]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <Spinner isFullPage />
      <h3 className="text-center" style={{ marginTop: "32%" }}>
        {cms("message.success.wait")}
      </h3>
    </div>
  );
};

export default withErrorBoundary(GenericShopifyCallback);
